<template>
  <basic-master
    masterName="代理店（法人）"
    insertDataPageName="addon-port-master-enterprise-agency-insert"
    viewPageName="addon-port-master-enterprise-agency-view"
    @callDelete="callDelete"
    @callSearch="callSearch"
    @callFetchAll="callFetchAll"
    @callUpdateOrder="callUpdateOrder"
    @updateDisplayItems="updateDisplayItems"
    :storedSearchKeyword="storedSearchKeyword"
    :data="data"
    :columns="columns"
    :pagination="true"
    :totalPages="totalPages"
    :totalItems="totalItems"
    :currentPage="currentPage"
    :displayItems="displayItems"
    :incrementSearch="false"
    :sortable="false"
    :editable="false"
    ref="basicMaster"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      totalPages: 0,
      totalItems: 0,
      currentPage: 0,
      displayItems: {
        number: 10
      },
      columns: [
        {
          displayName:"代理店名",
          inputType: "string",
          key: "name",
          cellClass: "agency-name",
          searchable: true,
        },
        {
          displayName:"略称",
          inputType: "string",
          key: "short_name",
          searchable: true,
        },
        {
          displayName:"請求先",
          inputType: "string",
          key: "billing_address",
          searchable: true,
        },
        {
          displayName:"電話番号",
          inputType: "string",
          key: "tel",
          searchable: true,
        },
        {
          displayName:"管理コード",
          inputType: "string",
          key: "admin_code",
          searchable: true,
        },
        {
          displayName:"港湾",
          inputType: "string",
          key: "ports",
          searchable: true,
        },
      ],
      data: [],
      storedSearchKeyword: "",
    }
  },
  async created() {
    this.refreshData()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
    }),
  },
  methods: {
    ...mapActions(["fetchEnterpriseAgencies", "updateEnterpriseAgency", "deleteEnterpriseAgency", "searchEnterpriseAgencies", "updateEnterpriseAgencyOrders"]),
    updateDisplayItems(number) {
      this.displayItems = number
    },
    extractPortString(shippingAgencies) {
      let object = shippingAgencies.map(element => {
        let portString = element.ports.map(port => {
          return port.port.name
        }).join()
        return {
          ...element,
          ports: portString
        }
      })
      return object
    },
    async refreshData() {
      let payload = {
        portId: this.selectedPort.id,
        query: {
          limit: 10,
          page: this.currentPage,
        }
      }
      this.$vs.loading()
      let res = await this.searchEnterpriseAgencies(payload)
      this.$vs.loading.close()

      this.data = this.extractPortString(res.shipping_agencies)
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
    },
    async callFetchAll() {
      let payload = {
        portId: this.selectedPort.id,
      }
      this.$vs.loading()
      let res = await this.fetchEnterpriseAgencies(payload)
      this.$vs.loading.close()
      this.data = this.extractPortString(res.shipping_agencies)
      this.$refs.basicMaster.forceUpdateTable(this.data)
    },
    async callSearch(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, "keyword")) this.storedSearchKeyword = condition.keyword
      let payload = {
        portId: this.selectedPort.id,
        query: {
          limit: condition.limit,
          page: condition.page,
        }
      }
      if (this.storedSearchKeyword) payload.query.name = this.storedSearchKeyword // TODO: 検索の仕様確認
      this.$vs.loading()
      let res = await this.searchEnterpriseAgencies(payload)
      this.$vs.loading.close()
      this.data = this.extractPortString(res.shipping_agencies)
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
      this.currentPage = condition.page
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteEnterpriseAgency(payload)
      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
      this.$vs.loading.close()
      let condition = {
        limit: this.displayItems.number,
        page: 0,
      }
      this.callSearch(condition)
    },
    async callUpdateOrder(sortOrders) {
      this.storedSearchKeyword = ""
      let payload = {
        portId: this.selectedPort.id,
        body: {
          sort_orders: sortOrders
        }
      }
      this.$vs.loading()
      await this.updateEnterpriseAgencyOrders(payload)
      this.$vs.loading.close()
      let condition = {
        limit: this.displayItems.number,
        page: 0,
      }
      this.callSearch(condition)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
